module.exports = __webpack_public_path__ + "img/content-new-2.70017f7.png";